import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { SET_WORKER_DRAIN } from "./gql";

const useSetWorkerDrain = createDefaultMutationHook(SET_WORKER_DRAIN);
export const useBulkSetWorkerDrain = createBulkMutationHook(SET_WORKER_DRAIN);

export default useSetWorkerDrain;
